import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

export interface WizardFooterProps {
  onVoltar?: () => void;
  onProximo?: () => void;
  voltarLabel?: string;
  proximoLabel?: string;
  voltarVariant?: string;
  proximoVariant?: string;
  voltarDisabled?: boolean;
  proximoDisabled?: boolean;
  isSubmit?: boolean;
  showVoltar?: boolean;
  showProximo?: boolean;
  spacerHeight?: string | number;
  className?: string;
  children?: React.ReactNode;
}

export const WizardFooterComponent: React.FC<WizardFooterProps> = ({
  onVoltar,
  onProximo,
  voltarLabel = "Voltar",
  proximoLabel = "Próximo",
  voltarVariant = "outline-secondary",
  proximoVariant = "outline-primary",
  voltarDisabled = false,
  proximoDisabled = false,
  isSubmit = true,
  showVoltar = true,
  showProximo = true,
  spacerHeight = "85px",
  className = "",
  children,
}) => {
  return (
    <>
      {/* Espaçador no fluxo normal do documento que evita a sobreposição do conteúdo final pelo rodapé fixo */}
      <div style={{ height: spacerHeight }} aria-hidden="true" />

      {/* Barra de rodapé fixa, opaca e sem transparência */}
      <div
        className={`fixed-bottom border-top py-3 shadow-sm bg-body ${className}`.trim()}
        style={{
          backgroundColor: "var(--bs-body-bg, #f4f6f8)",
          zIndex: 1030,
        }}
      >
        <Container>
          {children ? (
            children
          ) : (
            <Row>
              {showVoltar && (
                <Col xs={showProximo ? 6 : 12} className="d-grid">
                  <Button
                    variant={voltarVariant}
                    onClick={onVoltar}
                    disabled={voltarDisabled}
                    type="button"
                  >
                    {voltarLabel}
                  </Button>
                </Col>
              )}
              {showProximo && (
                <Col xs={showVoltar ? 6 : 12} className="d-grid">
                  <Button
                    variant={proximoVariant}
                    onClick={onProximo}
                    disabled={proximoDisabled}
                    type={isSubmit ? "submit" : "button"}
                  >
                    {proximoLabel}
                  </Button>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </div>
    </>
  );
};

export default WizardFooterComponent;
